import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_financial_summary,
    getReportLabel: () => t`Financial Summary`,
    getColumns: () => [],
};
